"use strict";

exports.__esModule = true;
exports.formatPercent = formatPercent;

function formatPercent(value, decimals = 1) {
  value = parseFloat(value);
  return value.toFixed(decimals) + "%";
}